var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.33,24.67c-0.609-0.611-1.544-0.761-2.317-0.371l-10.443,5.285c-0.028,0.014-0.049,0.035-0.076,0.051 c-0.08,0.045-0.157,0.097-0.232,0.154c-0.047,0.036-0.093,0.072-0.137,0.112c-0.021,0.019-0.045,0.033-0.066,0.054L39.127,48.887 L25.481,52.59c-0.336,0.092-0.644,0.27-0.89,0.517l-3.171,3.171c-0.375,0.375-0.586,0.884-0.586,1.414s0.211,1.039,0.586,1.414 l3.744,3.744l-0.154,0.154c-0.375,0.375-0.586,0.884-0.586,1.414s0.211,1.039,0.586,1.414l5.159,5.158 c0.391,0.391,0.902,0.586,1.414,0.586s1.024-0.195,1.414-0.586l0.154-0.154l3.744,3.745c0.375,0.375,0.884,0.586,1.414,0.586 s1.039-0.211,1.415-0.586l3.171-3.172c0.247-0.247,0.424-0.554,0.516-0.891l3.703-13.645l18.932-18.932 c0.021-0.021,0.036-0.046,0.056-0.068c0.038-0.042,0.073-0.086,0.107-0.132c0.059-0.077,0.112-0.156,0.159-0.239 c0.014-0.025,0.035-0.046,0.048-0.072L71.7,26.987C72.091,26.216,71.941,25.281,71.33,24.67z M27.042,56.312l6.396-1.736 l-5.446,5.446l-2.33-2.33L27.042,56.312z M65.378,30.622l-1.285,2.539l-1.254-1.254L65.378,30.622z M39.689,68.957l-1.381,1.382 l-2.33-2.331l5.446-5.446L39.689,68.957z M43.909,54.421c0,0-0.001,0-0.001,0.001L31.736,66.594 c-0.002,0.002-0.003,0.004-0.004,0.005l-0.149,0.149l-2.33-2.33l30.22-30.22l2.33,2.33L43.909,54.421z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissle);
export default __webpack_public_path__ + "static/media/missle.f3739c580ffa1764e13ceceef96b7821.svg";
export { ForwardRef as ReactComponent };